import React from 'react';

const Support = () => (
  <div style={{ padding: 32 }}>
    <h2>Support</h2>
    <p>This is the Support page. Add your support information here.</p>
  </div>
);

export default Support;
